/* eslint-disable jsdoc/check-param-names */
import { Dispatch, SetStateAction } from "react";
import { Box, Stack, TextField, Typography } from "@mui/material";

type Props = {
  label: string;
  text: string;
  required?: boolean;
  width?: number | string;
};

/**
 * ラベルのあるテキスト
 * @param label ラベル
 * @param text テキスト
 * @param required 必須かどうか
 * @param width 幅指定
 * @returns JSX.Element
 */
export default function LabeledText({ label, text, required, width = 0 }: Props) {
  return (
    <Stack direction="row" spacing={2} alignItems="center" width={width} margin="0 auto">
      <Box textAlign="right" marginRight={1}>
        {label}
        {required && <Typography color="red">{" *"}</Typography>}：
      </Box>
      <Box>
        <Typography>{text}</Typography>
      </Box>
    </Stack>
  );
}
